module.exports = __webpack_public_path__ + "img/leftFlip@2x(1).312060e1.png";